<div class="login-wrapper">
    <a (click)="logout($event)" class="small" [href]="" da-link [innerHTML]="'logout.headerLink' | translate"></a>
</div>
